import { createApp } from 'vue';

import axios from 'axios';

import ImageGalleryModal from '@js/src/components/ImageGalleryModal.vue';
import MobileGalleryOverlay from '@js/src/components/MobileGalleryOverlay.vue';
import PropertyStats from '@js/src/components/PropertyStats.vue';
import SpecialOffersSubscribeInline from '@js/src/components/SpecialOffersSubscribeInline.vue';
import ReviewsModal from '@js/src/components/ReviewsModal.vue';
import SubmitReviewModal from '@js/src/components/SubmitReviewModal.vue';
import Availability from '@js/src/components/Availability.vue';
import PropertyPriceChecker from '@js/src/components/PropertyPriceChecker.vue';
import EnquiryForm from '@js/src/components/EnquiryForm.vue';
import TruncatedContent from '@js/src/components/TruncatedContent.vue';
import EnquiryPriceSummary from '@js/src/components/EnquiryPriceSummary.vue';

import SpinnerIcon from '@img/icons/spinner.svg?raw';

const app = createApp({
    data() {
        return {
            imageGalleryModalActive: false,
            activeSlide: 0,
            reviewsModalActive: false,
            submitReviewModalActive: false,
            phoneNumberLoading: false,
            phoneNumber: '',
            // Set by the inline subscribe component's revealed event; the
            // special-offers card's Twig-rendered locked-state copy v-shows
            // against it so "Free to join" doesn't outlive the subscribe.
            specialOffersRevealed: false,
            SpinnerIcon,
        };
    },

    methods: {
        openImageGalleryModal(slideIndex) {
            this.activeSlide = slideIndex;

            this.imageGalleryModalActive = true;
        },

        closeImageGalleryModal() {
            this.imageGalleryModalActive = false;
        },

        loadPhoneNumber() {
            this.phoneNumberLoading = true;

            axios.get(`/wp-json/lh/v1/properties/${Page.postId}`, {
                params: {
                    meta: [
                        'owner_phone',
                    ],
                },
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': Page.nonce,
                },
            })
                .then(response => {
                    this.phoneNumber = response.data.meta?.owner_phone || '';
                })
                .catch(error => {
                    const responseErrors = error?.response?.data?.data?.errors || {};
                    const firstError = Object.values(responseErrors)[0] || '';

                    alert(
                        Object.values(firstError)[0] ?
                            Object.values(firstError)[0] :
                            (error?.response?.data?.message || 'Sorry, an error occurred.'));
                })
                .finally(() => {
                    this.phoneNumberLoading = false;
                });
        }
    },
});

const vm = app
    .component('imagegallerymodal', ImageGalleryModal)
    .component('mobilegalleryoverlay', MobileGalleryOverlay)
    .component('propertystats', PropertyStats)
    .component('specialofferssubscribeinline', SpecialOffersSubscribeInline)
    .component('reviewsmodal', ReviewsModal)
    .component('submitreviewmodal', SubmitReviewModal)
    .component('availability', Availability)
    .component('propertypricechecker', PropertyPriceChecker)
    .component('enquiryform', EnquiryForm)
    .component('truncatedcontent', TruncatedContent)
    .component('enquirypricesummary', EnquiryPriceSummary)
    .mount('#property');

// The hero and the two preview photos sit ABOVE #property, outside the Vue
// app, so they paint without waiting for it (see the comment over the
// section in single-property.php). They open the gallery by index from here.
document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-open-gallery]');

    if (!button) {
        return;
    }

    event.preventDefault();
    vm.openImageGalleryModal(Number(button.dataset.openGallery) || 0);
});
